export default "__VITE_ASSET__B_B38LN3__"